import React from 'react';
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import InputBase from '@mui/material/InputBase';
import Typography from '@mui/material/Typography';
import {isNullOrNaN} from './Bs4Utils';

// count={bs4PageProps.lastPage} 
// page={bs4PageProps.currentPage + 1} 
// onChange={(event, page) => this.bs4HandleChangePage(page)}

export const Bs4Pagination = (props) => {
  const theme = useTheme();
  const [pageNumber, setPageNumber] = React.useState(props.page)

  React.useEffect(() => {
    setPageNumber(props.page)
  }, [props.page]);

  const handleAnglesLeft = (event) => {
    // console.log('...Bs4Pagination.AnglesLeft..First', 0)
    handleChange(1);
  }

  const handleAngleLeft = (event) => {
    // console.log('...Bs4Pagination.AngleLeft..Prev', props.page)
    handleChange(props.page - 1);
  }

  const handleAngleRight = (event) => {
    // console.log('...Bs4Pagination.AngleRight..Next', props.page)
    handleChange(props.page + 1);
  }

  const handleAnglesRight = (event) => {
    // console.log('...Bs4Pagination.AnglesRight..Last', props.count)
    handleChange(props.count);
  }

  const handleInputChange = (event) => {
    console.log('...Bs4Pagination.InputChange..', event.target.value)
    let value = parseInt(event.target.value);
    if (value < 1) value = 1;
    if (value > props.count) value = props.count;
    // console.log('...Bs4Pagination.InputChange..', event.target.value , value)
    setPageNumber(value)
  }

  const handleChange = (value) => {
    if (isNullOrNaN(value)) value = 1;
    if (value < 1) value = 1;
    if (value > props.count) value = props.count;
    // console.log('...Bs4Pagination.Change..', value)    
    if (props.onChange) props.onChange(null, value);
  }

  const handleKeyDown = (event) => {    
    // console.log('...Bs4Pagination.handleKeyDown..', event)
    if (event.key === 'Enter') if (props.onChange) props.onChange(null, pageNumber);
  }

  // console.log('...Bs4Pagination...', props);

  if (parseFloat(props.count) < 1) return null;
  
  return (
    <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1.5}>
      <IconButton onClick={handleAnglesLeft}><i className="fa-solid fa-angles-left"/></IconButton>
      <IconButton onClick={handleAngleLeft}><i className="fa-solid fa-angle-left"/></IconButton>
      <InputBase
        type='number'
        value={pageNumber}
        onChange={handleInputChange}
        sx={{
          '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {display: 'none'},
          '& input[type=number]': {MozAppearance: 'textfield'},
          width: '40px',
        }}
        onKeyDown={handleKeyDown}
      />
      <Typography>{'z'}</Typography>
      <Typography>{props.count}</Typography>
      <IconButton onClick={handleAngleRight}><i className="fa-solid fa-angle-right"/></IconButton>
      <IconButton onClick={handleAnglesRight}><i className="fa-solid fa-angles-right"/></IconButton>
    </Stack>
  )
};

export default Bs4Pagination;
  
  